import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FC } from 'react'
import CalendarArrowUpIcon from '../../../../assets/icons/CalendarArrowUp.svg?react'
import {
    NumberPostfixConfig,
    NumberWithCorrectPostfix,
} from '../../../../components/NumberWithCorrectPostfix'
import { regularRequestsChipPostfix } from '../../../../constants/regularRequests.constants'
import { useWrapperStore } from '../../../../store/storeWrapper'

const mobilePostfix: NumberPostfixConfig = {
    endsWithOne: 'рег. запрос',
    endsBetweenTwoAndFour: 'рег. запроса',
    other: 'рег. запросов',
}

type Props = {
    requestsCount: number
    threadId: number
}

export const RegularRequestsChip: FC<Props> = ({ requestsCount, threadId }) => {
    const { breakpoints } = useTheme()
    const isMobile = useMediaQuery(breakpoints.down('md'))

    const { setOpenRegularRequestsDialogThreadId } = useWrapperStore((state) => state)

    const handleOpenRegularRequests = () => {
        setOpenRegularRequestsDialogThreadId(threadId)
    }

    return (
        <Box
            onClick={handleOpenRegularRequests}
            sx={{
                height: 'fit-content',
                width: 'fit-content',
                minWidth: 'fit-content',
                backgroundColor: '#EFF6FF',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                borderRadius: '100px',
                gap: '6px',
                p: '2px 8px 2px 6px',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}>
                <CalendarArrowUpIcon width={16} height={16} color="#006CFD" />
            </Box>
            <Typography variant="caption2" color="#006CFD">
                <NumberWithCorrectPostfix
                    value={requestsCount}
                    postfix={isMobile ? mobilePostfix : regularRequestsChipPostfix}
                />
            </Typography>
        </Box>
    )
}
